import {
  createGlobalStyle,
  sanitize,
  theme,
} from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'

import brandFonts from '../fonts/brands'

const fontSize = (props) => {
  const baseFont = theme('base.fontSize')(props)
  const remSize = rem(baseFont)(props)
  return remSize
}

const lineHeight = (props) => {
  const baseFont = theme('base.lineHeight')(props)
  const remSize = rem(baseFont)(props)
  return remSize
}

export default createGlobalStyle`
  ${sanitize};
  ${brandFonts};

  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
  }

  body {
    padding: 0;
    font-size: ${fontSize};
    line-height: ${lineHeight};
    letter-spacing: ${(p) => p.theme.base.letterSpacing};
    font-weight: ${(p) => p.theme.base.fontWeight};
    color: ${(p) => p.theme.colors.textColor};
    background-color: ${(p) => p.theme.base.backgroundColor};
    font-family: ${(p) => p.theme.base.fontFamily};
  }

  p {
    font-family: ${(p) => p.theme.base.fontFamily} !important;
  }

  button {
    background-color: transparent;
    cursor: pointer;
    border: 0;
    font-family: inherit;
  }
`
